// Campus photo for /colleges/university-of-wyoming: CC BY-SA 2.0, by Tony Webster, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AOld_Main_Building_-_University_of_Wyoming_(53242406082).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-wyoming/; credited under the photo.
const photo = {
    "slug": "university-of-wyoming",
    "alt": "The sandstone entrance of Old Main framed by tree branches at the University of Wyoming in Laramie, Wyoming",
    "src": "/colleges/university-of-wyoming/campus-1600.webp",
    "srcSmall": "/colleges/university-of-wyoming/campus-800.webp",
    "srcMid": "/colleges/university-of-wyoming/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-wyoming/og.jpg",
    "title": "Old Main Building - University of Wyoming (53242406082)",
    "author": "Tony Webster",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AOld_Main_Building_-_University_of_Wyoming_(53242406082).jpg",
    "read": "2026-10-01"
};

export default photo;
